import { render, staticRenderFns } from "./DialogSelectCustomization.vue?vue&type=template&id=1f666e8a&scoped=true&"
import script from "./DialogSelectCustomization.vue?vue&type=script&lang=js&"
export * from "./DialogSelectCustomization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f666e8a",
  null
  
)

export default component.exports